import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import ArrowButton from '../../../../../../../components/arrow-button';
import { ROUTES } from '../../../../../../../routes/routes';

type AutoCalibrationProps = {
  channel: IDeviceChannel;
};

const AutoCalibration: React.FC<AutoCalibrationProps> = ({ channel }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('device-info');

  const goToAutoCalibration = () => {
    if (channel) {
      navigate(ROUTES.BlindAutoCalibration(channel.ChannelId));
    }
  };

  return (
    <ArrowButton
      title={`${t('exalus.calibration')} ${t('exalus.autoCalibration')}`}
      onClick={goToAutoCalibration}
      className="m-b-24"
    />
  );
};

export default AutoCalibration;
